import VueRouter from 'vue-router'
import Vue from 'vue'
import myHome from "@@/views/myHome.vue"
import myApp from "@@/views/myApp.vue"
// 通过vue.use(插件)，安装插件
const routerRePush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
    return routerRePush.call(this, location).catch(error => error)
}
Vue.use(VueRouter)
// 创建路由对象
const routes = [
    {
        path: '/',
        component: myApp,
        children:[
            {
                path: '/home',
                name: "MyHome",
                component: myHome,
                meta: {
                    title: '河北旭诚智联供应链有限公司'
                }
            }, {
                path: '/download',
                name: "Download",
                component: () => import("@@/views/myDownload.vue"),
                meta: {
                    title: '下载中心-河北旭诚智联供应链有限公司'
                }
            },
            {
                path: '/about',
                name: "myAbout",
                component: () => import("@@/views/myAbout.vue"),
                meta: {
                    title: '交易信息-河北旭诚智联供应链有限公司'
                }
            },
            {
                path: '/ggDetail',
                name: "ggDetail",
                component: () => import("@@/views/ggDetail.vue"),
                meta: {
                    title: '交易信息-河北旭诚智联供应链有限公司'
                }
            },
            {
                path: '/notice',
                name: "notice",
                component: () => import("@@/views/myNotice.vue"),
                meta: {
                    title: '通知公告-河北旭诚智联供应链有限公司',
                }
            },
            {
                path: '/law',
                name: "law",
                component: () => import("@@/views/myLaw.vue"),
                meta: {
                    title: '法律法规-河北旭诚智联供应链有限公司',
                }
            },
            {
                path: '/lawDetail',
                name: "lawDetail",
                component: () => import("@@/views/lawDetail.vue"),
                meta: {
                    title: '法律法规-详情-河北旭诚智联供应链有限公司',
                }
            },
            {
                path: '/newsDetail',
                name: "newsDetail",
                component: () => import("@@/views/newsDetail.vue"),
                meta: {
                    title: '通知公告-详情-河北旭诚智联供应链有限公司'
                }
            }, {
                path: '/help',
                name: "Help",
                component: () => import("@@/views/myHelp.vue"),
                meta: {
                    title: '帮助中心-河北旭诚智联供应链有限公司'
                }
            }, {
                path: '/helpDetail',
                name: "helpDetail",
                component: () => import("@@/views/helpDetail.vue"),
                meta: {
                    title: '帮助中心-河北旭诚智联供应链有限公司'
                }
            }, {
                path: '/ourself',
                name: "OurSelf",
                component: () => import("@@/views/ourSelf.vue"),
                meta: {
                    title: '关于我们-河北旭诚智联供应链有限公司'
                }
            },
        ]
    },{
        path:'/login',
        name:'loginMain',
        component:()=>import("@@/views/LoginMain.vue")
    },
    {
        path:'/register',
        name:'RegisterMain',
        component:()=>import("@@/views/RegisterMain.vue")
    },
    {
        path:'/vendorRegister',
        name:'vendorRegisterMain',
        component:()=>import("@@/views/vendorRegisterMain.vue")
    },
    {
        path:'/zjRegister',
        name:'zjRegisterMain',
        component:()=>import("@@/views/zjRegister.vue")
    },
    {
        path:'/marketRegister',
        name:'marketRegister',
        component:()=>import("@@/views/marketRegister.vue")
    },
    {
        path:'/realname',
        name:'realName',
        component:()=>import("@@/views/RealnameMain.vue")
    },
    {
        path:'/realnametwo',
        name:'realNameTwo',
        component:()=>import("@@/views/RealnameMainTwo.vue")
    },
    {path:'*',redirect:'/home'},
    {
        path:'/review',
        name:'Review',
        component:() => import("@@/views/ReviewMain.vue"),
        meta:{
            title:'专家评审'
        }
    },
    {
        path: '/redirect',
        component: () => import('@/views/RedirectTo'),
        name: 'extappsRedirect',
        hidden: true
    }
]
const router = new VueRouter({
    // 配置URL和组价直接的映射关系
    routes,
    // history模式
    mode: 'history'
})
// 将router对象传入到vue实例中
export default router
